<main id="main-content" class="h-screen h-full flex flex-col pl-8 pr-4 py-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <h1 class="oswald-font text-3xl uppercase">
                Closed
            </h1>
            <assess-assistant></assess-assistant>
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start overflow-y-auto">
        <div class="w-full max-h-full bg-white rounded-md shadow-custom-2 p-6 overflow-y-auto">
            <router-outlet class="h-full"></router-outlet>
        </div>
    </div>
    

</main>